module.exports = __webpack_public_path__ + "static/img/success7.cf5db80e.png";